<template>
	<v-card v-can="'claimreserves.create'">
		<v-card-title
			class="d-flex align-center mb-4"
		>
			<v-icon
				icon="$cashMultiple"
				start
			/>
			<translate>Adjust reserve without document</translate>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col
					cols="12"
					sm="6"
					lg="4"
				>
					<price-field
						ref="price"
						v-model="reserveAmount"
						:label="$gettext('New reserve')"
						field-name="Reserve"
					/>
				</v-col>
			</v-row>
			<v-row />
			<v-row>
				<v-col
					cols="12"
					sm="6"
					lg="4"
				>
					<v-text-field
						v-model="reserveComment"
						variant="outlined"
						:label="$gettext('Reserve update comment')"
						:placeholder="$gettext('Comments')"
					/>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-spacer />
			<v-btn
				color="primary"
				@click="updateReserve"
			>
				<translate>Update</translate>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import {
	displayError, inform,
} from 'laravel-front-library';

export default {
	name: 'ReserveUpdateCard',
	props: {
		claimId: {
			type: Number,
			required: true,
		}
	},

	data () {
		return {
			reserveAmount: '',
			reserveComment: ''
		};
	},

	methods: {
		/**
		 * Update reserve of the claim
		 */
		updateReserve () {
			if (this.$refs.price.validatePrice(this.reserveAmount)) {
				axios.post('/bo/claims/reserveupdate', {
					'id': this.claimId,
					'amountReserve': this.reserveAmount,
					'messageReserve': this.reserveComment,
				}).then(() => {
					inform(this.$gettext('Updated'));
					setTimeout(() => {
						window.location.reload();
					}, 300);
				}).catch((error) => {
					displayError(this.$gettext('Something has gone wrong'));
					window.captureException(error);
				});
			}
		}
	}
};
</script>

<style scoped>

</style>
